<script>
import MinimalLayout from '@/components/layouts/minimal/MinimalLayout';
import animate from '@/modules/animate-css';

export default {
  name: 'Login',
  components: {
    MinimalLayout
  },
  metaInfo() {
    return { title: this.title };
  },
  data() {
    return {
      title: this.$t('Login'),
      token: '',
      invalid: [],
      isVerifying: false
    };
  },
  mounted() {
    this.$refs.token.focus();
  },
  methods: {
    handleSubmit() {
      this.invalid = [];
      this.isVerifying = true;

      // Verify the two-factor auth token
      this.$http
        .post('/auth/tfa', {
          userId: this.$store.state.user.id,
          token: this.token
        })
        .then(() => {
          // Set two-factor auth status
          this.$store.commit('setTfa', {
            isRequiredByAccount: this.$store.state.user.account.requiresTfa,
            isRequired: this.$store.state.user.requiresTfa,
            isVerified: true
          });

          // Redirect to the homepage or to the specified ?to
          if (this.$route.query.to) {
            this.$router.push(this.$route.query.to);
          } else {
            this.$router.push({ name: 'Home' });
          }
        })
        .catch(err => {
          const data = err.response.data;
          const status = err.response.status;

          if (status === 400) {
            this.invalid = Array.isArray(data.invalid) ? data.invalid : [];
            animate(document.querySelector('.minimal-body'), 'shake', 1.25);
          } else {
            this.$notify({
              type: 'error',
              title: this.$t('Error'),
              message: this.$t('An error occurred. Please try your request again later.')
            });
          }
        })
        .finally(() => (this.isVerifying = false));
    }
  }
};
</script>

<template>
  <minimal-layout>
    <el-form ref="loginForm" label-position="top" @submit.native.prevent="handleSubmit">
      <p>{{ $t('Please open your authentication app and enter the two-factor authentication code here.') }}</p>

      <!-- Token -->
      <el-form-item :class="{ 'tfa-token': true, 'is-error': invalid.includes('token') }" :label="$t('Code')">
        <el-input ref="token" v-model="token" inputmode="numeric" type="text" auto-complete="off" />
      </el-form-item>

      <!-- Login button -->
      <el-form-item>
        <el-button :loading="isVerifying" type="primary" native-type="submit" class="el-button--block">
          {{ $t('Login') }}
        </el-button>
      </el-form-item>

      <!-- Recovery link -->
      <div class="text-center">
        <small>
          <router-link :to="{ name: 'RecoverTfa' }">
            {{ $t('Lost your device?') }}
          </router-link>
        </small>
      </div>
    </el-form>
  </minimal-layout>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.tfa-token /deep/ .el-input__inner {
  font-size: 2rem;
  height: 3.5rem;
  line-height: 3.5rem;
}
</style>
